<div class="profile-image">
  <!-- Banner section -->
  <div class="banner-container">
    <img
      class="banner"
      [src]="profile.banner"
      onerror="this.src='/assets/images/fallback-banner.png';"
      [alt]="'Banner'"
      />
      <div class="fab-background">
        <fab-no-title [icon]="'edit'" (click)="edit()"></fab-no-title>
      </div>
      <!-- Image Section -->
      <div class="image-section">
        <div class="user-image-holder">
          <img
            [src]="getProfilePicture()"
            onerror="this.src = '/assets/images/user.png';"
            class="user-image"
            [alt]="'Afbeelding gebruiker'"
            />
          </div>
          @if (!!profile.name && profile.name !== ' ') {
            <span
              class="username"
              >{{ profile.name }}</span
              >
          }
          @if (!profile.name || profile.name === ' ') {
            <span
              class="username"
              >{{ profile.userName }}</span
              >
            }
            <!-- User Text Image -->
            @if (userRole === 'user') {
              <img
                class="user-logo"
                src="/assets/images/tekst_streapp_white.svg"
                [alt]="'StreApp Reporter'"
                />
            }
            <!-- Reporter Text Image -->
            @if (userRole === 'reporter') {
              <img
                class="reporter-logo"
                src="/assets/images/streapp-reporter-white-gold.png"
                [alt]="'StreApp Reporter'"
                />
            }
          </div>
        </div>
      </div>